import React from "react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-logo">
            <img
              src="https://customer-assets.emergentagent.com/job_29fbdd7a-12d4-4367-bb60-da83a4682749/artifacts/hsju6cfd_DTIT-LOGO-Final-11825_page-0001.jpg"
              alt="DoubleTap Innovations Logo"
              className="footer-logo-img"
            />
          </div>

          <div className="footer-info">
            <p className="footer-copyright">
              © {currentYear} DoubleTap Innovations and Technologies Pvt. Ltd.
            </p>
            <p className="footer-tagline">
              Empowering the future through innovation
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
